<div class="mt-0 mb-3 mx-1 bg-stone-200/50 dark:bg-gray-800/90 p-2 px-4 rounded-b-lg shadow-md">
    <div class="flex text-m mb-0 flext justify-between gap-4 items-baseline text-black dark:text-white">
        <!-- Slot for pagination/actions -->
        <slot />
    </div>
</div> 